module.exports = __webpack_public_path__ + "static/media/DINING 2.9a859306.jpg";